import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Reveal } from "@/components/site/Reveal";
import { Timeline } from "@/components/site/Timeline";
import { CtaBand } from "@/components/site/CtaBand";
import { Icon } from "@/components/site/Icon";
import { SOLUTIONS, IMAGES } from "@/data/content";

const Solutions = () => {
  return (
    <>
      <PageHero
        eyebrow="Solutions"
        title="More than trade. An end-to-end business solution."
        subtitle="Rely on us across multiple stages of the supply chain — from sourcing the right products to delivering them, with everything handled in between."
        image={IMAGES.inspection}
      />

      <section className="bg-white py-24 lg:py-32" data-testid="solutions-grid">
        <div className="container-x">
          <SectionHeading
            eyebrow="What We Offer"
            title="Ten ways we support your supply chain"
            subtitle="Engage us for a single service or for complete, coordinated trade management."
          />

          <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SOLUTIONS.map((s, i) => {
              const featured = i === 0 || i === 9;
              return (
                <Reveal key={s.title} delay={(i % 3) * 0.07} className={featured ? "sm:col-span-2 lg:col-span-1" : ""}>
                  <div
                    className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-[#fafafa] p-8 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                    data-testid={`solution-card-${i}`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[color:var(--brand-blue)]/10 text-[color:var(--brand-blue)] transition-transform duration-300 group-hover:scale-110">
                        <Icon name={s.icon} className="h-7 w-7" />
                      </div>
                      <span className="font-[Outfit] text-3xl font-extrabold text-slate-200">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <h3 className="mt-6 text-xl font-bold text-slate-950">{s.title}</h3>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                    <Link
                      to="/contact"
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--brand-red)]"
                    >
                      Discuss Your Requirement
                      <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                    </Link>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-[#fafafa] py-24 lg:py-32" data-testid="solutions-process">
        <div className="container-x">
          <SectionHeading eyebrow="How We Work" title="Coordinated from first brief to final delivery" />
          <div className="mt-14">
            <Timeline />
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
};

export default Solutions;
